// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  firebase: {
    projectId: '{{APP_PROJECTID}',
    appId: '1:176323389159:web:a56772b77f8dc065fde442',
    storageBucket: 'sakura-app-c22e3.appspot.com',
    apiKey: 'AIzaSyCL_Ae6z70wzZsILz0GNPlJ48g5s6QfRfE',
    authDomain: 'sakura-app-c22e3.firebaseapp.com',
    messagingSenderId: '1.76323389159e+11',
    measurementId: 'G-13HMDCTKYY',
  },
  title: 'Sakura',
  production: false,
  baseUrl: 'https://test.hrm-z2s.lookinsoft.ru/',
  publicUrl: '',
  downloadUrl: 'index.php?r=api/pwa/download{{APP_DOWNLOADURL}}url=',
  apiUrl: 'index.php',
  requestPrefix: 'api/',
  requestParam: 'r',
  socketUrl: 'https://testapi.chat.lobster.lookinsoft.ru',
  uploadUrl: 'https://testapi.chat.lobster.lookinsoft.ru'
  // socketUrl: 'https://chat.sakura.staging.lobsterlab.io',
  // uploadUrl: 'https://chat.sakura.staging.lobsterlab.io/upload'
  // version: pcj.version,
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
import 'zone.js/dist/zone-error';  // Included with Angular CLI.
